<template>
  <div v-if="start">
    <div v-if="!currentGroup">
      <p>Такой группы не существует</p>
    </div>
    <div v-else class="w-full">
      <vx-card class="mb-6">
        <div class="vx-card__title mb-10">
          <h4 class="mb-4">Настройки группы операторов «{{ currentGroup.name }}»</h4>
          <p>Распределите обязанности и настройте доступы операторов.</p>
        </div>
        <div class="vx-row mb-12">
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-input
              class="w-full"
              label="Название группы: *"
              name="name"
              v-model="currentSettings.name"
              v-validate="'required'"
              :class="isEditedClass(currentSettings.name, settings.name)"
            />
            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-input
              class="w-full"
              label="Описание группы:"
              name="description"
              v-model="currentSettings.description"
              :class="isEditedClass(currentSettings.description, settings.description)"
            />
            <span class="text-danger text-sm" v-show="errors.has('description')">{{ errors.first('description') }}</span>
          </div>
        </div>
        <div class="vx-card__title mb-10">
          <h4 class="mb-4">Настройка доступов</h4>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-checkbox
              class="items-start"
              v-model="currentSettings.permissions['company.show']"
              :class="isEditedClass(currentSettings.permissions['company.show'], settings.permissions['company.show'])"
            >
              <div class="ml-2">
                <div class="mb-2"><b>Показ компании</b></div>
                Группа может просматривать компанию, но не редактировать.
              </div>
            </vs-checkbox>
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-checkbox
              class="items-start"
              v-model="currentSettings.permissions['company.operator.manage']"
              :class="isEditedClass(currentSettings.permissions['company.operator.manage'], settings.permissions['company.operator.manage'])"
            >
              <div class="ml-2">
                <div class="mb-2"><b>Управление операторами</b></div>
                Группа может редактировать и удалять операторов. Для управления операторами включите «Показ операторов».
              </div>
            </vs-checkbox>
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-checkbox
              class="items-start"
              v-model="currentSettings.permissions['company.manage']"
              :class="isEditedClass(currentSettings.permissions['company.manage'], settings.permissions['company.manage'])"
            >
              <div class="ml-2">
                <div class="mb-2"><b>Управление компанией</b></div>
                Группа может редактировать описание компании, часы работы, сервисное меню, список клиентов, чаты, самих операторов. Для управления компанией включите «Показ компании».
              </div>
            </vs-checkbox>
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-checkbox
              class="items-start"
              v-model="currentSettings.permissions['company.channel.list']"
              :class="isEditedClass(currentSettings.permissions['company.channel.list'], settings.permissions['company.channel.list'])"
            >
              <div class="ml-2">
                <div class="mb-2"><b>Показ каналов</b></div>
                Группа может видеть все созданные каналы.
              </div>
            </vs-checkbox>
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-checkbox
              class="items-start"
              v-model="currentSettings.permissions['company.operator.list']"
              :class="isEditedClass(currentSettings.permissions['company.operator.list'], settings.permissions['company.operator.list'])"
            >
              <div class="ml-2">
                <div class="mb-2"><b>Показ операторов</b></div>
                Группа может просматривать список операторов.
              </div>
            </vs-checkbox>
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-checkbox
              class="items-start"
              v-model="currentSettings.permissions['company.channel.manage']"
              :class="isEditedClass(currentSettings.permissions['company.channel.manage'], settings.permissions['company.channel.manage'])"
            >
              <div class="ml-2">
                <div class="mb-2"><b>Управление каналами</b></div>
                Группа может просматривать и редактировать каналы. Для управления каналами включите Показ каналов.
              </div>
            </vs-checkbox>
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-checkbox
              class="items-start"
              v-model="currentSettings.permissions['conversation.view_all']"
              :class="isEditedClass(currentSettings.permissions['conversation.view_all'], settings.permissions['conversation.view_all'])"
            >
              <div class="ml-2">
                <div class="mb-2"><b>Просмотр новых обращений</b></div>
                Операторы внутри группы видят все обращения клиентов.
              </div>
            </vs-checkbox>
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-checkbox
              class="items-start"
              v-model="currentSettings.permissions['report.manage']"
              :class="isEditedClass(currentSettings.permissions['report.manage'], settings.permissions['report.manage'])"
            >
              <div class="ml-2">
                <div class="mb-2"><b>Просмотр отчетов</b></div>
                Разрешить операторам просматривать отчетность по каналам.
              </div>
            </vs-checkbox>
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-checkbox
              class="items-start"
              v-model="currentSettings.permissions['wa_chat_api.chat_first']"
              :class="isEditedClass(currentSettings.permissions['wa_chat_api.chat_first'], settings.permissions['wa_chat_api.chat_first'])"
            >
              <div class="ml-2">
                <div class="mb-2"><b>Возможность писать новым клиентам</b></div>
                Группа операторов сможет самостоятельно писать новым клиентам и создавать повторные обращения, если такой функционал включен в настройках канала (WhatsApp).
              </div>
            </vs-checkbox>
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-checkbox
              class="items-start"
              v-model="currentSettings.permissions['bulk_delivery.manage']"
              :class="isEditedClass(currentSettings.permissions['bulk_delivery.manage'], settings.permissions['bulk_delivery.manage'])"
            >
              <div class="ml-2">
                <div class="mb-2"><b>Возможность создавать массовые рассылки</b></div>
                Группа операторов сможет самостоятельно создавать массовые рассылки для клиентов.
              </div>
            </vs-checkbox>
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-checkbox
              class="items-start"
              v-model="currentSettings.permissions['widget.manage']"
              :class="isEditedClass(currentSettings.permissions['widget.manage'], settings.permissions['widget.manage'])"
            >
              <div class="ml-2">
                <div class="mb-2"><b>Управление виджетами</b></div>
                Разрешить операторам создавать и настраивать виджеты для подключения на сайте
              </div>
            </vs-checkbox>
          </div>
        </div>
      </vx-card>
      <groups-edit-members
        :company-slug="authUserCompany.slug"
        :group-slug="currentGroup.slug"
      />

      <SaveBlock
        :show="hasChanges"
        :loading="loading"
        @accept="saveSettings"
        @cancel="cancelChanges"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { copyObject, compareObjects, isEditedClass } from '../../helpers/helpers'
import Groups from '../../api/http/models/Groups'
import GroupsEditMembers from './GroupsEditMembers'

export default {
  data () {
    return {
      start: false,
      loading: false,
      currentGroup: null,
      currentSettings: null,
      hasChanges: false,
      settings: {
        name: '',
        description: '',
        permissions: {
          'company.show': false,
          'company.manage': false,
          'company.operator.list': false,
          'company.operator.manage': false,
          'company.channel.list': false,
          'company.channel.manage': false,
          'conversation.view_all': false,
          'wa_chat_api.chat_first': false,
          'report.manage': false,
          'bulk_delivery.manage': false,
          'widget.manage': false
        }
      }
    }
  },
  computed: mapGetters(['authUserCompany']),
  components: {
    GroupsEditMembers
  },
  watch: {
    currentSettings: {
      deep: true,
      handler (newValue) {
        this.hasChanges = !compareObjects(newValue, this.settings)
      }
    }
  },
  async created () {
    const group = await Groups.getOne(this.authUserCompany.slug, this.$route.params.groupSlug)
    if (group.data) {
      this.setData(group.data)
    }

    await this.copySettings()

    this.start = true
  },
  methods: {
    isEditedClass,
    cancelChanges () {
      this.copySettings()
    },
    setData (data) {
      this.currentGroup = data
      this.settings.name = this.currentGroup.name
      this.settings.description = this.currentGroup.description
      for (const permission in this.settings.permissions) {
        this.settings.permissions[permission] = this.currentGroup.permissions.includes(permission)
      }
    },
    async saveSettings () {
      const validate = await this.$validator.validateAll()

      if (validate) {
        this.loading = true
        const permissions = []

        for (const [key, value] of Object.entries(this.currentSettings.permissions)) {
          if (value) {
            permissions.push(key)
          }
        }

        const updatedGroup = await Groups.updateOne(this.authUserCompany.slug, this.currentGroup.slug, {
          name: this.currentSettings.name,
          description: this.currentSettings.description,
          permissions
        })

        if (updatedGroup.status === 'success' && updatedGroup.data) {
          this.setData(updatedGroup.data)
          this.copySettings()
          this.$vs.notify({
            color: 'success',
            title: 'Группа обновлена',
            text: `Обновление группы «${this.currentGroup.name}» прошло успешно`
          })
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Произошла ошибка',
            text: ''
          })
        }
      }

      this.loading = false
    },
    copySettings () {
      this.currentSettings = copyObject(this.settings)
    }
  }
}
</script>
